import { create } from 'zustand';
import { produce } from 'immer';
/** How often to re-fetch a journal while its suggested title is being generated. */
export const JOURNAL_TITLE_POLL_INTERVAL_MS = 2_000;
/** How long to wait for a suggested title before falling back to the date title. */
export const JOURNAL_TITLE_GENERATION_TIMEOUT_MS = 30_000;
const initialState = {
    pending: {},
};
/**
 * Journals the user has just saved without a title, whose AI-suggested title the
 * background tagging function has yet to write. Lets the journal list show a
 * "generating" state instead of the date title and then swapping it out on the
 * next refetch.
 */
export const useJournalTitleGenerationStore = create((set) => ({
    ...initialState,
    markPending: (journalId) => set(produce((state) => {
        state.pending[journalId] = Date.now();
    })),
    clearPending: (journalId) => set(produce((state) => {
        delete state.pending[journalId];
    })),
    reset: () => set(initialState),
}));
